module["exports"] = ["Västra", "Östra", "Norra", "Södra", "Övre", "Undre"];